import { useState, useEffect } from 'react';

export function Sidebar({ activeView, userProfile, windowWidth }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleToggle = (e) => {
      setMobileMenuOpen(e.detail.open);
    };

    window.addEventListener('toggleMobileMenu', handleToggle);
    return () => window.removeEventListener('toggleMobileMenu', handleToggle);
  }, []);

  // Reset mobile menu state when switching to desktop
  useEffect(() => {
    if (windowWidth >= 768) {
      setMobileMenuOpen(false);
    }
  }, [windowWidth]);

  const closeMobileSidebar = () => {
    if (windowWidth < 768 && mobileMenuOpen) {
      setMobileMenuOpen(false);
      // Sync with AppHeader
      window.dispatchEvent(new CustomEvent('toggleMobileMenu', { detail: { open: false } }));
    }
  };

  const handleNavigation = (view) => {
    window.location.hash = `#${view}`;
    if (window.innerWidth < 768) {
      setMobileMenuOpen(false);
      // Sync with AppHeader
      window.dispatchEvent(new CustomEvent('toggleMobileMenu', { detail: { open: false } }));
    }
  };

  return (
    <>
      {/* Overlay for mobile - click outside to close */}
      {windowWidth < 768 && mobileMenuOpen && (
        <div className="sidebar-overlay" onClick={closeMobileSidebar} />
      )}

      <aside className={`sidebar ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <nav className="sidebar-nav">
          <ul>
            <li>
              <button
                className={activeView === 'dashboard' ? 'active' : ''}
                onClick={() => handleNavigation('dashboard')}
              >
                <i className="fas fa-tachometer-alt"></i>
                <span>Dashboard</span>
              </button>
            </li>
            <li>
              <button
                className={activeView === 'tasks' ? 'active' : ''}
                onClick={() => handleNavigation('tasks')}
              >
                <i className="fas fa-tasks"></i>
                <span>Aufgaben</span>
              </button>
            </li>
            {userProfile.role === 'admin' && (
              <>
                <li>
                  <button
                    className={activeView === 'templates' ? 'active' : ''}
                    onClick={() => handleNavigation('templates')}
                  >
                    <i className="fas fa-layer-group"></i>
                    <span>Vorlagen</span>
                  </button>
                </li>
                <li>
                  <button
                    className={activeView === 'locations' ? 'active' : ''}
                    onClick={() => handleNavigation('locations')}
                  >
                    <i className="fas fa-map-marker-alt"></i>
                    <span>Standorte</span>
                  </button>
                </li>
                <li>
                  <button
                    className={activeView === 'users' ? 'active' : ''}
                    onClick={() => handleNavigation('users')}
                  >
                    <i className="fas fa-users"></i>
                    <span>Benutzer</span>
                  </button>
                </li>
              </>
            )}
          </ul>
        </nav>
      </aside>
    </>
  );
}
